// Detects whether a search-box input is a supported source-platform product URL.
// Backend `/address/resolve` is the source of truth for parsing; this guard only
// decides "is this a URL we should hand to resolve" vs "treat as a keyword search".
// Keep the host list aligned with the backend resolvers (Taobao / Tmall / 1688 /
// Weidian / Pinduoduo). Over-matching here just means a doomed resolve call that
// falls back to the "cannot resolve" toast — under-matching silently routes a
// real link into keyword search, so err toward the documented hosts only.

const PRODUCT_URL_HOST_PATTERNS = [
  "taobao.com",
  "tmall.com",
  "tmall.hk",
  "tb.cn",
  "1688.com",
  "weidian.com",
  "youshop10.com", // weidian short-link host (k.youshop10.com)
  "pinduoduo.com",
  "yangkeduo.com", // pinduoduo alternate host
  "yesgo.shop",
] as const;

/** True when `input` contains an http(s) URL on a supported source platform. */
export function isProductUrl(input: string): boolean {
  const value = input.trim();
  if (!/https?:\/\//i.test(value)) return false;
  const lower = value.toLowerCase();
  return PRODUCT_URL_HOST_PATTERNS.some((host) => lower.includes(host));
}
